import {gql} from 'apollo-angular';

export const GET_PROFILES_ROOKIE_SUGGESTION_DETAILS = gql`
  query GetProfilesSearchResults ($uuid: String!) {
    companyProfile(uuid: $uuid) {
      name
      uuid

      locations {
        address {
          number
          street
          addressCity {
            name
            zip
          }
        }
      }

      contactGallery {
        galleryEntries {
          id
          contact {
            person {
              firstname
              lastname


            }
            communication {
              entries {
                entryValue
                communicationType {
                  shortName
                }
              }
            }
          }
        }
      }
    }
  }
`;
